class ReadMore {
    constructor (theme, elem) {
        this._elem = elem
        this._class = elem.classList
    }

    onInit () {
        this._toggleClass()
    }

    _toggleClass () {
        this._elem.addEventListener('click', () => {
            let readMore = document.querySelector('.read-more-2')
            let readLess = document.querySelector('.read-less-2')

            readMore.classList.toggle('hidden')
            readLess.classList.toggle('hidden')

            /* if(this._class.contains('read-more')){
                this._class.remove('read-more')
                this._class.add('read-less')
            }else{
                this._class.remove('read-less')
                this._class.add('read-more')
            } */
        })
    }
}

export default ReadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ReadMore.js